import { useMemo } from 'react'

export const usePageViewEvent = () => {
  useMemo(() => {
    if (typeof window !== 'undefined' && typeof document === 'object') {
      const dataLayerObj = {
        event: 'pageView',
        location: window.location.href,
        page: `${document.location.pathname}`,
        referrer: '',
        title: '',
      }

      window.dataLayer = window.dataLayer || []

      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push(dataLayerObj)

      return true
    }

    return false
  }, [])
}

export const useDepartmentViewEvent = () => {
  useMemo(() => {
    if (typeof window !== 'undefined' && typeof document === 'object') {
      const dataLayerObj = {
        event: 'departmentView',
        departmentId: undefined,
        departmentName: `${
          document.location.pathname.split('/').slice(1)[0] || ''
        }`,
        target: 1,
      }

      window.dataLayer = window.dataLayer || []

      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push(dataLayerObj)

      return true
    }

    return false
  }, [])
}

export const useCategoryViewEvent = () => {
  useMemo(() => {
    if (typeof window !== 'undefined' && typeof document === 'object') {
      const dataLayerObj = {
        event: 'categoryView',
        categoryId: undefined,
        categoryName: `${
          document.location.pathname.split('/').slice(1)[1] || ''
        }`,
        target: 2,
      }

      window.dataLayer = window.dataLayer || []

      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push(dataLayerObj)

      return true
    }

    return false
  }, [])
}
